import useMartyContext from 'hooks/useMartyContext';
import type { AirplaneCacheUnitOption } from 'types/AirplaneCache';
import { Toggle } from 'tailwind/components/Toggle/Toggle';

import css from 'styles/components/productdetail/sizeUnitTabs.scss';

interface Props {
  onChange: (option: AirplaneCacheUnitOption) => void;
  options: AirplaneCacheUnitOption[];
  selectedOption: AirplaneCacheUnitOption;
}

export default function SizeUnitTabs(props: Props) {
  const { onChange, options } = props;
  const { testId } = useMartyContext();
  const optionLabels = options.map(option => option?.label);

  return (
    <div className={css.container} data-test-id={testId('sizingUnitPicker')}>
      <Toggle
        size="small"
        testId={testId('sizingUnitOption')}
        options={optionLabels}
        onValueChange={label => onChange(options.find(option => option.label === label)!)}
      />
    </div>
  );
}
